import React from "react";
import { Route, Routes } from "react-router-dom";
import FarmerDailyActivity from "../component/farmer/dailyActivity/FarmerDailyActivity";
import FarmerDailyActivityDetail from "../component/farmer/dailyActivity/FarmerDailyActivityDetail";
import FarmerDailyActivityTambah from "../component/farmer/dailyActivity/FarmerDailyActivityTambah";
import FarmerDebtPlastic from "../component/farmer/debt-plastic/FarmerDebtPlastic";
import FarmerDebtPlasticDetail from "../component/farmer/debt-plastic/FarmerDebtPlasticDetail";
import FarmerDebtPlasticEdit from "../component/farmer/debt-plastic/FarmerDebtPlasticEdit";
import FarmerDebtPlasticTambah from "../component/farmer/debt-plastic/FarmerDebtPlasticTambah";
import FarmerHarvest from "../component/farmer/harvest/FarmerHarvest";
import FarmerHarvestDetail from "../component/farmer/harvest/FarmerHarvestDetail";
import FarmerHarvestEstimate from "../component/farmer/harvestEstimate/FarmerHarvestEstimate";
import FarmerHarvestEstimateDetail from "../component/farmer/harvestEstimate/FarmerHarvestEstimateDetail";
import AdminPurchaseOrder from "../component/farmer/purchaseOrder/AdminPurchaseOrder";
import AdminPurchaseOrderDetail from "../component/farmer/purchaseOrder/AdminPurchaseOrderDetail";
import AdminMain from "../component/layout/AdminMain";
import Login from "../component/login/Login";
import PrivateRoute from "./PrivateRoute";

export default function FarmerRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <AdminMain />
          </PrivateRoute>
        }
      />
      <Route
        path="/petani"
        element={
          <PrivateRoute>
            <AdminMain />
          </PrivateRoute>
        }
      >
        <Route
          path="/petani/aktifitas-harian"
          element={
            <PrivateRoute>
              <FarmerDailyActivity />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/aktifitas-harian/detail/:id"
          element={
            <PrivateRoute>
              <FarmerDailyActivityDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/aktifitas-harian/tambah"
          element={
            <PrivateRoute>
              <FarmerDailyActivityTambah />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/estimasi-panen"
          element={
            <PrivateRoute>
              <FarmerHarvestEstimate />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/estimasi-panen/detail/:id"
          element={
            <PrivateRoute>
              <FarmerHarvestEstimateDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/panen"
          element={
            <PrivateRoute>
              <FarmerHarvest />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/panen/detail/:id"
          element={
            <PrivateRoute>
              <FarmerHarvestDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/nota-petani"
          element={
            <PrivateRoute>
              <AdminPurchaseOrder />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/nota-petani/detail/:id"
          element={
            <PrivateRoute>
              <AdminPurchaseOrderDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/hutang-plastik"
          element={
            <PrivateRoute>
              <FarmerDebtPlastic />
            </PrivateRoute>
          }
        />   <Route
        path="/petani/hutang-plastik/tambah"
        element={
          <PrivateRoute>
            <FarmerDebtPlasticTambah/>
          </PrivateRoute>
        }
        />
        <Route
            path="/petani/hutang-plastik/edit/:id"
            element={
              <PrivateRoute>
                <FarmerDebtPlasticEdit/>
              </PrivateRoute>
            }
            />
              <Route
            path="/petani/hutang-plastik/detail/:id"
            element={
              <PrivateRoute>
                <FarmerDebtPlasticDetail/>
              </PrivateRoute>
            }
            />
      </Route>
    </Routes>
  );
}
